import {refreshTeamCreditsInStore} from '@Components/team-credits/team-credits-library';
import {closeStockMediaPopup} from '@Components/poster-editor/components/poster-add-item-bar/components/stock-media-dropdown/stock-media-popup-controller';
import {openCheckoutForCreditPackPurchase} from '@Modals/checkout-modal/checkout-modal.library';
import {divertCreditPackPurchaseToTeamAdmin} from '@Components/checkout-flow/credit-pack-eligibility.library';
import type {CreditPackCheckoutOptions} from '@Components/checkout-flow/checkout-flow.types';
import {getTeamCreditsForUser} from '@Libraries/user.library';
import {noop} from '@Utils/general.util';

export const buyCreditPack = (onPurchased: () => void = noop): void => {
  openCheckoutForCreditPackPurchase(getCreditPackCheckoutOptions(onPurchased));
};

/**
 * A team member cannot buy credits and already sees the team's balance on hover, so for them the pill stays
 * inert until the team runs out, and only then sends them to ask their admin.
 */
export const buyCreditPackUnlessTeamMemberHasCredits = (): void => {
  openCheckoutForCreditPackPurchase({
    ...getCreditPackCheckoutOptions(noop),
    onIneligibleBuyer: (): void => {
      void divertTeamMemberOnceTeamIsOutOfCredits();
    },
  });
};

const divertTeamMemberOnceTeamIsOutOfCredits = async (): Promise<void> => {
  if (await hasTeamCreditsRemaining()) {
    return;
  }
  divertCreditPackPurchaseToTeamAdmin(closeStockMediaPopup);
};

/**
 * Reads the balance from the server: the team-credits store is seeded at page load and not every AI spend
 * refreshes it. An unreadable balance counts as none, so a member is never left with a pill that does nothing.
 */
const hasTeamCreditsRemaining = async (): Promise<boolean> => {
  try {
    const teamCredits = await getTeamCreditsForUser();
    return teamCredits.credits > 0;
  } catch {
    return false;
  }
};

const getCreditPackCheckoutOptions = (onPurchased: () => void): CreditPackCheckoutOptions => {
  return {
    headingText: '',
    modalTitle: window.i18next.t('pmwjs_select_a_credit_pack'),
    onSuccess: (): void => {
      void refreshTeamCreditsInStore();
      onPurchased();
    },
    onOpen: closeStockMediaPopup,
  };
};
